import { useEffect, useState } from 'react';
import { useForm } from 'react-hook-form';
import { useParams } from 'react-router-dom';

export const ActionChangeZoneHook = ({
  changeZone,
  postChangeZone,
  cleanChangeZone,
  getEvents,
}) => {
  const params = useParams();

  const { ticketId } = params;

  const [modalOpen, setOpenModal] = useState(false);
  const [zoneValue, setZoneValue] = useState('9');
  const [loaderButton, setLoaderButton] = useState(false);

  const [errorMssge, setErrorMssge] = useState();
  const [severityAlert, setSeverityAlert] = useState('');

  const zones = [
    { value: '2' },
    { value: '3' },
    { value: '4' },
    { value: '5' },
    { value: '6' },
    { value: '7' },
    { value: '8' },
    { value: '9' },
  ];

  const { handleSubmit } = useForm();

  const onSubmit = async () => {
    const post = {
      ticket_id: ticketId,
      zone: zoneValue,
    };
    postChangeZone(post);
    setLoaderButton(true);
  };

  useEffect(() => {
    const hasData = changeZone.changeZone && Object.keys(changeZone.changeZone).length > 0;
    const hasError = changeZone.error && Object.keys(changeZone.error).length > 0;

    if (hasData && !hasError) {
      setSeverityAlert('success');
      setErrorMssge('El cambió de zona se realizó satisfactoriamente');
      setLoaderButton(false);
      getEvents({ ticket_id: ticketId });
      setTimeout(() => {
        setOpenModal(false);
      }, 3000);
    } else if (hasError) {
      const errorMsg =
        changeZone?.error?.response?.data?.detail || 'Hubo un error al cambiar de zona';
      setSeverityAlert('warning');
      setErrorMssge(errorMsg);
      setLoaderButton(false);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [changeZone]);

  const handleClickButton = () => {
    setOpenModal(true);
  };

  useEffect(() => {
    cleanChangeZone();
    setErrorMssge(undefined);
    setSeverityAlert('');
    setLoaderButton(false);
  }, [modalOpen, cleanChangeZone]);

  const handleSelectZone = (event) => {
    const zoneValue = event.target.value || '';
    setZoneValue(zoneValue);
  };

  const closePopup = () => {
    setOpenModal(false);
  };
  return {
    onSubmit,
    handleClickButton,
    handleSelectZone,
    closePopup,
    zoneValue,
    loaderButton,
    zones,
    handleSubmit,
    modalOpen,
    setOpenModal,
    errorMssge,
    severityAlert,
  };
};
